/* eslint-disable import/prefer-default-export */
export const blueDotFeature = {
  DOUBTS: 4
};
